import { useEffect, useLayoutEffect, useRef, useState } from 'react'

/** Keeps a floating box on screen and closes it on Escape or a press outside. */
export function useFloating(x: number, y: number, onClose: () => void, deps: unknown[] = []) {
  const ref = useRef<HTMLDivElement & HTMLFormElement>(null)
  const [position, setPosition] = useState({ left: x, top: y })

  useLayoutEffect(() => {
    const box = ref.current?.getBoundingClientRect()
    if (!box) return
    setPosition({
      left: Math.max(8, Math.min(x, window.innerWidth - box.width - 8)),
      top: Math.max(8, Math.min(y, window.innerHeight - box.height - 8)),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [x, y, ...deps])

  useEffect(() => {
    const away = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) onClose()
    }
    const key = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('pointerdown', away, true)
    window.addEventListener('keydown', key)
    window.addEventListener('resize', onClose)
    return () => {
      window.removeEventListener('pointerdown', away, true)
      window.removeEventListener('keydown', key)
      window.removeEventListener('resize', onClose)
    }
  }, [onClose])

  return { ref, position }
}
